import { Component, OnInit, inject, signal } from "@angular/core";
import { CommonModule } from "@angular/common";
import { ActivatedRoute } from "@angular/router";
import { FieldsetModule } from "primeng/fieldset";
import { MessageModule } from "primeng/message";
import { PlatformService } from "../../../platform-service";
import { LessonsToolsMappingService } from "../../services/lessons-tools-mapping.service";
import { GetContentItemsResponseDto } from "../../dtos/get-content-items.response.dto";
import { TargetLinkURICustomizationService } from "../../services/target-link-uri-customization.service";
import { LaunchToolDto, TestUser } from "../../../launch-tool/dtos/launch-tool.dto";
import { SessionService } from "../../../launch-tool/services/session.service";


@Component({
  selector: 'app-show-linked-sub-courses-test',
  standalone: true,
  imports: [
    CommonModule,
    FieldsetModule,
    MessageModule
  ],
  providers: [LessonsToolsMappingService,TargetLinkURICustomizationService,SessionService],
  templateUrl: './show-linked-sub-courses-test.html',
  styleUrls: ['./show-linked-sub-courses-test.css']
})
export class ShowLinkedSubCoursesTestComponent implements OnInit  {
    private route = inject(ActivatedRoute);
    private platformService = inject(PlatformService)
    private lessonsToolsMappingService = inject(LessonsToolsMappingService);
    private targetLinkURICustomizationService = inject(TargetLinkURICustomizationService)
    contentItems = signal<GetContentItemsResponseDto[]>([])
    courseCode:string =""
    ngOnInit(): void {
      this.courseCode = this.route.snapshot.params['courseCode'];
      this.lessonsToolsMappingService.getContentItemsForLesson(this.courseCode).then((data)=>{
        this.contentItems.set(data);
      })
    }

 /*
    ⚠️ this method does a LTI launch with a test user( not a user in session from RLMS )
 */ 
 
    async onLinkClick(contentItem: GetContentItemsResponseDto) {
      const targetLinkURI = await this.targetLinkURICustomizationService.getTargetLinkURIAsPerToolMappedTo(this.courseCode,contentItem);
      const userInfo: LaunchToolDto = {
          ...TestUser,
          "custom":contentItem.custom,
          courseCode: this.courseCode,
          targetLinkURI
      };
      const openInNewWindow = true;
      this.platformService.initiateCourseLaunch(this.courseCode, userInfo, openInNewWindow)
    }
}
